import RowInfoCard from './component'

export default RowInfoCard
